// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"HW6_buttonsContainer__TQAjy","editableSpanContainer":"HW6_editableSpanContainer__TSEqz"};